





















































import { defineComponent, PropType, ref } from '@vue/composition-api'
import { SearchResultProduct } from '@/interfaces/Search'
import AStarRating from '@/components/AStarRating'
import AIcon from '@/components/AIcon'
import { mdiCircleSmall } from '@mdi/js'

export default defineComponent({
  name: 'ASearchResultProduct',

  components: {
    AStarRating,
    AIcon,
  },

  props: {
    value: {
      type: Object as PropType<SearchResultProduct>,
      required: true,
    },
  },

  setup() {
    const hover = ref(false)
    return { hover, mdiCircleSmall }
  },
})
